<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：用户管理界面
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div class="manage">
		<el-dialog
		  title="提示"
		  :visible.sync="dialogVisible"
		  width="50%"
		  minWidth="380px"
		  :before-close="handleClose">
		  <!-- 用户的表单信息 -->
			<el-form ref="modifyForm" :inline="true" :rules="rules" :model="modifyForm_cols">
			  <el-form-item label="姓名" prop='name'>
				<el-input v-model="modifyForm_cols.name" placeholder="请输入姓名"></el-input>
			  </el-form-item>
			  <el-form-item label="年龄" prop='age'>
				<el-input v-model="modifyForm_cols.age" placeholder="请输入年龄"></el-input>
			  </el-form-item>
			  <el-form-item label="性别" prop='sex'>
				  <el-select v-model="modifyForm_cols.sex" placeholder="请选择性别">
					<el-option
					  v-for="item in sexOptions"
					  :key="item.value"
					  :label="item.label"
					  :value="item.value">
					</el-option>
				  </el-select>
			  </el-form-item>
			  <el-form-item label="出生日期" prop='birth'>
					<el-date-picker
					  v-model="modifyForm_cols.birth"
					  type="date"
					  placeholder="选择日期"
					  value-format="yyyy-MM-DD">
					</el-date-picker>
			  </el-form-item>
			  <el-form-item label="地址" prop='addr'>
				<el-input v-model="modifyForm_cols.addr" placeholder="请输入地址"></el-input>
			  </el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeForm('modifyForm')">关 闭</el-button>
				<el-button type="primary" @click="resetForm('modifyForm')">重 置</el-button>
				<el-button type="primary" @click="submitForm('modifyForm')">确 定</el-button>
			</span>
		</el-dialog>
		<div class="manage-header">
			<el-button @click="handleCreate()" type="primary">
				+ 新增
			</el-button>
			<el-form :inline="true" :model="userSearchForm_cols" class="userSearchForm_cols">
			  <el-form-item label="搜索" prop='name' class="searchform_str">
				<el-input v-model="userSearchForm_cols.name" class="el-input-for-search" placeholder="请输入搜索内容"></el-input>
			  </el-form-item>
			  <el-form-item style="padding:0px;margin:0px;">
				<el-button type="primary" @click="handlSearch">查 询</el-button>
			  </el-form-item>
			</el-form>
		</div>
		<el-table
		  :data="tableData.filter(data => !search 
			|| data.name.toLowerCase().includes(search.toLowerCase())
			|| data.age === parseInt(search)
			//|| data.sex.toLowerCase().includes(search.toLowerCase())
			|| data.birth.toLowerCase().includes(search.toLowerCase())
			|| data.addr.toLowerCase().includes(search.toLowerCase()))"
		  :stripe="true"
		  style="width: calc(100% - 0px);">
			<el-table-column
			  label="姓名"
			  prop="name">
			</el-table-column>
			<el-table-column
			  label="性别"
			  prop="sex">
			  <template slot-scope="scope">
				<!-- <span style="margin-left: 10px">{{ scope.row.sex === 1 ? '男' : '女' }}</span> -->
				<span style="margin-left: 10px">{{ getSexText(scope.row.sex) }}</span>
			  </template>  
			</el-table-column>
			<el-table-column
			  label="年龄"
			  prop="age">
			</el-table-column>
			<el-table-column
			  label="出生日期"
			  prop="birth">
			</el-table-column>
			<el-table-column
			  label="地址"
			  prop="addr">
			</el-table-column>
			<el-table-column
			  align="right">
				<template slot="header" slot-scope="scope">
					<el-input
					  v-model="search"
					  size="mini"
					  placeholder="输入关键字搜索"/>
				</template>
				<template slot-scope="scope">
					<el-button
					  size="mini"
					  @click="handleUpdate(scope.$index, scope.row)">修改</el-button>
					<el-button
					  size="mini"
					  type="danger"
					  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="background:#ffffff;text-align:right;margin-top:10px;padding:5px 0px;">
			<el-pagination
			  background
			  layout="prev, pager, next"
			  :total="total"
			  small
			  @current-change="handleCurrentPage">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import { getUserList, createUser, updateUser, deleteUser } from '../api/'
export default {
	data() {
		return {
			dialogVisible: false,
			// form 元素
			modifyForm_cols: {
			  name: '',
			  age: '',
			  sex: '',
			  birth: '',
			  addr: '',
			},
			userSearchForm_cols: {
				name: '',
			},
			// 性别的下拉裁断选择项
			sexOptions: [{
			  value: -1,
			  label: '保密'
			}, {
			  value: 1,
			  label: '男'
			}, {
			  value: 0,
			  label: '女'
			},],
			// 校验规则
			rules: {
				name: [
					{ required: true, message: "请输入姓名，不可以为空！", trigger: 'blur'},
					{ min: 2, max: 5, message: "长度必须为 2 到 5个字符！", trigger: 'blur'},
				],
				addr: [
					{ required: true, message: "请输入地址，不可以为空！", trigger: 'blur'},
				]
			},
			// 表格数据
			tableData: [],
			// 弹窗类型 0 新增 ， 1 修改
			modalType: 0,
			search: '',
			// 当前返回的总行数
			total: 0,
			pageData: {
				page: 1,
				limit: 10,
			}
		}
	}, 
	methods: {
		// 重置表单数据
		resetFormData() {
			this.modifyForm_cols = {
				name: '',
				age: '',
				sex: '',
				birth: '',
				addr: ''
			};
		},
		// 关闭按钮触发
		handleClose(done) {
			this.$confirm('确认关闭？')
			.then(_ => {
				this.closeForm("modifyForm");
				done();
			})
			.catch(_ => {});
		},
		// 列表搜索数据
		handlSearch() {
			this.handleGetUserList();
		},
		// 关闭添加窗口操作
		closeForm(formName) {
			//console.log(this.$refs[formName]);
			this.dialogVisible = false;
			this.$refs[formName].resetFields();
			this.resetFormData();
		},
		// 提交按钮
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				// 提交校验正确
				if (valid) {
					
					if(this.modalType == 0)
					{
						this.modifyForm_cols.sex = parseInt(this.modifyForm_cols.sex);
						createUser(this.modifyForm_cols).then(() => {
						});
						
						this.$message({
							type: 'success',
							message: '已创建成功！'
						});  
						
						const thisobj = this;
						setTimeout(function() {
							thisobj.handleGetUserList();
						},100);
					}
					else if(this.modalType == 1)
					{
						updateUser(this.modifyForm_cols).then(() => {
						});
						this.handleGetUserList();
						
						this.$message({
							type: 'success',
							message: '已更新成功！'
						});  
						
						const thisobj = this;
						setTimeout(function() {
							thisobj.handleGetUserList();
						},100);
					}
					
					//alert('submit!');
					this.closeForm(formName);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 重置按钮
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		//onSubmit() {
		//	console.log('submit!');
		//},
		handleCreate() {
			this.resetFormData();
			this.modalType = 0;
			this.dialogVisible = true;
			//this.resetForm();
		},
		handleUpdate(index, row) {
			this.resetFormData();
			this.modalType = 1;
			//console.log(index, row);
			this.dialogVisible = true;
			// 不能直接赋值
			//this.modifyForm_cols = row
			this.modifyForm_cols =  JSON.parse(JSON.stringify(row));
		},
		// 删除数据
		handleDelete(index, row) {
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteUser( { id: row.id } ).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				});
				//console.log(index, row);
				
				const thisobj = this;
				setTimeout(function() {
					thisobj.handleGetUserList();
				},100);
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
		},
		handleGetUserList() {
			//getUserList({ params: this.pageData}).then(({ data }) => {
			getUserList({ params: {...this.userSearchForm_cols, ...this.pageData}}).then(({ data }) => {
				//console.log(data);
				this.tableData = data.list;
				this.total = data.count ? data.count : 0;
			});
		},
		// 选择页码时调用
		handleCurrentPage(pageIndex) {
			//console.log(pageIndex);
			this.pageData.page = pageIndex;
			this.handleGetUserList();
		},
		// 获取性别信息
		getSexText(sexValue) {
			/* switch(sexValue) {
				case 1: return '男';
				case 0: return '女';
				case -1: return '未填';
				case -2: return '保密';
				default: return '未知';
			} */
			const option = this.sexOptions.find(item => parseInt(item.value) === parseInt(sexValue));
			return option ? option.label : '未知';
		},
	},
	mounted() {
		// 获得列表数据
		this.handleGetUserList();
	}
};
</script>
<style lang="less" Scoped>
.manage {
	height: 100%;
	/* min-height: 400px; */
	.manage-header {
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.userSearchForm_cols {
		padding: 0px;
		height: 40px;
		margin: 0px;
	}
	.el-table-main {
	}
	
	@media (max-width: 600px) {
		.el-input-for-search {
			width: 120px;
		}
	}
}
</style>